module.exports = require('./arc');



/** WEBPACK FOOTER **
 ** ./~/arc/index.js
 **/